/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { ValidationForm, TextInput, SelectGroup, Checkbox } from 'react-bootstrap4-form-validation';
import { useDispatch } from 'react-redux';
import DatePicker from "react-datepicker";
import {
    createYarnProjection,
    createYarnProjectionUserForm,
    deleteYarnProjection,
    fetchCombinedSlNo,
    fetchPrNo,
    fetchYarnProjection,
    fetchYarnProjectionOverAllReports,
    fetchYarnProjectionReports,
    getSingleYarnProjection,
    updateYarnProjection
    //updateFldSubject // subject validations 0407
} from '../../store/yarnProjection/yarnProjection.actions';
import { useSelector } from '../../store/reducer';
import { RESET_YARN_MASTER_INFO } from '../../store/yarnMaster/yarnMaster.actionsType';
import {
    CREATE_AND_CLOSE_BUTTON,
    DELETE_BUTTON,
    FEEDBACK_MODAL_OPEN,
    MODAL_CLOSE,
    MODAL_OPEN,
    PROPERTY_MODAL_OPEN,
    UPDATE_BUTTON
} from '../../store/actions';
import Select from 'react-select';
import Loader from '../../App/layout/Loader';
import '../../assets/scss/themes/pages/_userHeader.scss';
import { PROPERTY_MASTER } from '../../store/propertyMaster/propertyMaster.reducer';
import { getIpAddress } from '../../store/propertyMaster/propertyMaster.actions';
import CommonPropertyModal from '../../App/components/CommonPropertyModal';
import CommonFeedbackModal from '../../App/components/CommonFeedbackModal';
import DataGrid, {
    Paging,
    Scrolling,
    Pager,
    SearchPanel,
    FilterRow,
    HeaderFilter,
    Column,
    ColumnChooser,
    ColumnFixing,
    FilterPanel,
    Button as ActionButton,
    Export,
    Selection,
    Summary,
    TotalItem
} from 'devextreme-react/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import { COMMON_PROPERTY } from '../../store/property/common/commonProperty.reducer';
import { fetchCommonPropertyById } from '../../store/property/common/commonProperty.actions';
import ReactDatePicker from 'react-datepicker';
import { UNIT_MASTER } from '../../store/unitMaster/unitMaster.reducer';
import { fetchUnitMaster } from '../../store/unitMaster/unitMaster.actions';
import makeAnimated from 'react-select/animated';
import {
    fetchYarnPOSectionDropdown,
    fetchYarnPOSupplierDropdown,
    fetchYarnPOSupplierDropdown2
} from '../../store/programs/YarnPO/yarnPO/yarnPO.actions';
import { YARN_PROJECTION } from '../../store/yarnProjection/yarnProjection.reducer';
import { RESET_COMBINED_SL_NO, RESET_YARN_PROJECTION_INFO } from '../../store/yarnProjection/yarnProjection.actionsType';
import { YARN_PO } from '../../store/programs/YarnPO/yarnPO/yarnPO.reducer';
import { fetchPartyDetailsData } from '../../store/partyDetails/partyDetails.action';
import { PARTY_DETAILS } from '../../store/partyDetails/partyDetails.reducer';
import { YARN_MASTER } from '../../store/yarnMaster/yarnMaster.reducer';
import { fetchYarnMasterDataDetails } from '../../store/yarnMaster/yarnMaster.action';
import { fetchYarnPODetailsGroupListDropdown } from '../../store/programs/YarnPO/yarnPODetails/yarnPODetails.actions';
import { YARN_PO_DETAILS } from '../../store/programs/YarnPO/yarnPODetails/yarnPODetails.reducer';
import moment from 'moment/moment';
import { SET_UNIT_NAME_YARN_PO } from '../../store/programs/YarnPO/yarnPO/yarnPO.actionsType';
import { useHistory } from 'react-router-dom';
import './style.css'

let apiCallId;

const componentId = 'yarnProjectionFeedback';


const YarnProjection = ({ isReportScreen }) => {
    const exportFormats = ['xlsx', 'pdf'];
    let dispatch = useDispatch();
    const reset = useRef();
    let history = useHistory();
    const [fabricChecker, setFabricChecker] = useState()

    let [selectedList, setSelectedList] = useState();
    const [isOverAll, setIsOverAll] = useState(true);

    let { isFormModal, buttonStatus } = useSelector((state) => {
        return state.able;
    });

    let { yarnProjectionList, yarnProjectionForm, loading, prNo, combinedSlNo, yarnProjectionReportsList, yarnProjectionFormData, yarnProjectionOverAllReport } = useSelector(
        (state) => {
            return state[YARN_PROJECTION];
        }
    );
    let { ipAddressInfo } = useSelector((state) => {
        return state[PROPERTY_MASTER];
    });

    let { millName, yarnMaterial, agentName } = useSelector((state) => {
        return state[COMMON_PROPERTY];
    });
    let { unitMaster } = useSelector((state) => {
        return state[UNIT_MASTER];
    });
    let { supplierList, unitId } = useSelector((state) => {
        return state[YARN_PO];
    });
    let { partyDetailsWithoutId } = useSelector((state) => {
        return state[PARTY_DETAILS];
    });
    let { yarnMasterList } = useSelector((state) => {
        return state[YARN_MASTER];
    });
    let { groupList } = useSelector((state) => {
        return state[YARN_PO_DETAILS];
    });
    const [fldPRDate, setFldPRDate] = useState(new Date());
    const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - 15));

    const [endDate, setEndDate] = useState(new Date());

    const [showGrid, setShowGrid] = useState(false);
    const [addNewOption, setAddNewOption] = useState(null);


    const matchingProjection = yarnProjectionList.filter((item) => item.fldGroupPRNo === prNo[0]?.fldGroupPRNo);




    const determineAndDisplayPRNumber = () => {
        // Find an existing PR number based on Unit ID and Supplier ID
        const existingPRNumber = yarnProjectionList.find(
            (item) =>
                item.fldFKUnitId === yarnProjectionForm.fldFKUnitId || yarnProjectionFormData.fldFKUnitId &&
                item.fldFKSupplierID === yarnProjectionForm.fldFKSupplierID || yarnProjectionFormData.fldFKSupplierID
        )?.fldGroupPRNo;


        if (addNewOption === 'addNew' && existingPRNumber) {
            // If in 'addNew' mode and an existing PR number is found, display it
            return existingPRNumber;
        }
        // Default to 'Auto Generated' if no PR number exists or no match is found
        return 'Auto Generated';
    };


    useEffect(() => {
        let findIdx = supplierList.findIndex((x) => x.fldId === parseInt(yarnProjectionFormData.fldFKSupplierID));

        const currentDate = moment(new Date()).format('YYYY-MM-DD')

        let disableFabricProjection = yarnProjectionList?.filter((x) => x.fldPRDate.split('T')[0] === currentDate)

        if (addNewOption === 'addNew') {
            const lastObject = disableFabricProjection.filter((x) => x.fldSupplierName === supplierList[findIdx]?.fldName && x.fldFKUnitId == yarnProjectionFormData?.fldFKUnitId);

            setFabricChecker(lastObject)

            if (lastObject?.length > 0) {
                dispatch(createYarnProjectionUserForm('fldIsFabricProjection', lastObject[0]?.fldIsFabricProjection));
            } else {
                dispatch(createYarnProjectionUserForm('fldIsFabricProjection', false));
            }
        }

    }, [addNewOption, yarnProjectionFormData?.fldFKSupplierID, yarnProjectionList.length])

    // Use the method to determine the PR number to display
    const displayValue = determineAndDisplayPRNumber();

    // useEffect(() => {

    //     const fetchAndSetPRNumber = () => {
    //         if (buttonStatus === 'create') {
    //             const newPRNumber = determineAndDisplayPRNumber();

    //             if (prNo?.length > 0) {
    //                 console.log('newPRNumber', newPRNumber)
    //                 dispatch(fetchCombinedSlNo(newPRNumber));
    //             }

    //         }
    //     };

    //     fetchAndSetPRNumber();
    // }, [prNo, dispatch, buttonStatus, yarnProjectionForm, yarnProjectionFormData, fldPRDate]);


    const handleCheckboxChange = () => {
        setShowGrid(!showGrid);
    };

    // yarnProjectionList and ip address API call
    useEffect(() => {
        dispatch(fetchYarnProjection(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId));
        dispatch(getIpAddress());
        dispatch(fetchYarnPODetailsGroupListDropdown());
        // dispatch(fetchPrNo(yarnProjectionForm.fldFKUnitId, yarnProjectionForm.fldFKSupplierID, fldPRDate));
        // dispatch(fetchCombinedSlNo(yarnProjectionForm?.fldGroupPRNo));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    // useEffect(() => {
    //     if (yarnProjectionForm?.fldFKSupplierID && yarnProjectionForm?.fldFKUnitId && fldPRDate) {
    //         dispatch(fetchPrNo(yarnProjectionForm.fldFKUnitId, yarnProjectionForm.fldFKSupplierID, fldPRDate));
    //     }
    // }, [yarnProjectionForm.fldFKSupplierID, yarnProjectionForm.fldFKUnitId, fldPRDate, dispatch]);

    useEffect(() => {
        if (unitId) {
            dispatch(fetchYarnProjection(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId));
        }
        dispatch(getIpAddress());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        if (buttonStatus === 'create' && prNo && prNo?.length > 0) {
            dispatch(fetchCombinedSlNo(prNo[0].fldGroupPRNo));
        }
    }, [prNo, dispatch]);


    useEffect(() => {
        if (buttonStatus === 'update' && yarnProjectionForm.fldFKUnitId) {
            dispatch(fetchYarnPOSectionDropdown(yarnProjectionForm.fldFKUnitId));
        }
    }, [buttonStatus, yarnProjectionForm.fldFKUnitId]);


    useEffect(() => {
        if (prNo && prNo?.length == 0) {
            dispatch({ type: RESET_COMBINED_SL_NO })
        }

    }, [yarnProjectionForm.fldFKUnitId, yarnProjectionForm.fldFKSupplierID, prNo])

    useEffect(() => {
        window.addEventListener('keydown', (event) => {
            let charCode = String.fromCharCode(event.which).toLowerCase();
            if ((event.ctrlKey || event.metaKey) && charCode === 'a') {
                event.preventDefault();
                commonOpenModalActions();
            }
        });
        return () => {
            return () => {
                window.removeEventListener('keydown', () => { }, false);
            };
        };
    }, []);

    const commonOpenModalActions = () => {
        dispatch({ type: MODAL_OPEN });
        dispatch({ type: CREATE_AND_CLOSE_BUTTON });
        dispatch(fetchCommonPropertyById(58)); //Mill Name
        // dispatch(fetchCommonPropertyById(80)); // Yarn Material
        dispatch(fetchCommonPropertyById(57)); //Agent Name
        // dispatch(fetchPartyDetailsData());
        dispatch(fetchYarnMasterDataDetails());
        dispatch(fetchYarnPOSupplierDropdown('TblYarnPO'));
        dispatch(fetchUnitMaster());
        // dispatch(fetchPrNo(yarnProjectionForm.fldFKUnitId, yarnProjectionForm.fldFKSupplierID, fldPRDate));
        // dispatch(fetchCombinedSlNo(yarnProjectionForm.fldGroupPRNo));
        setAddNewOption('')
        //dispatch(fetchYarnPOSupplierDropdown2('TblProgramSupplier'));
    };
    const calculateValue = (name) => {
        if (name === 'fldPRWeight') {
            return Number(yarnProjectionForm?.fldBagWeight) * Number(yarnProjectionForm?.fldNoofBags);
        }
    };

    // handleCheckboxChange function
    const handleRateCheckboxChange = (e) => {
        const { checked } = e.target;
        handleChange({ target: { name: 'FldIsExMillRate', value: checked } }, 'FldIsExMillRate');
    };


    const handleChange = (event) => {
        let key = event.target.name;
        let value = event.target.value;

        if (key === 'fldFKUnitId') {
            dispatch(createYarnProjectionUserForm('fldFKSupplierID', ''));
        }
        if (key === 'fldPRWeight') {
            let temp = Number(yarnProjectionForm?.fldBagWeight) * Number(yarnProjectionForm?.fldNoofBags);
            dispatch(createYarnProjectionUserForm('fldPRWeight', temp));
        } else if (key === 'fldFKYarn') {
            // key = name;
            // value = event;
            let findIdx = groupList.findIndex((x) => x.fldId === parseInt(value));
            if (findIdx !== -1) {
                dispatch(createYarnProjectionUserForm('fldYarnDescription', groupList[findIdx].fldDescription));
                dispatch(createYarnProjectionUserForm('fldFKYarnGroup', groupList[findIdx].fldFKYarnGroup));
                dispatch(createYarnProjectionUserForm('fldYarnGroup', groupList[findIdx].tblPropertyYarnGroup.fldDescription));
                dispatch(createYarnProjectionUserForm('fldFKYarnType', groupList[findIdx].fldFKYarnType));
                dispatch(createYarnProjectionUserForm('fldYarnType', groupList[findIdx].tblPropertyYarnType.fldDescription));
            }
        } else if (key === 'fldFKSupplierID') {
            // key = name;
            // value = event;
            let findIdx = supplierList.findIndex((x) => x.fldId === parseInt(value));
            if (findIdx !== -1) {

                dispatch(fetchPrNo(yarnProjectionForm.fldFKUnitId, value, fldPRDate));

                dispatch(createYarnProjectionUserForm('fldSupplierName', supplierList[findIdx].fldName));
                dispatch(createYarnProjectionUserForm('fldSupplierAddress1', supplierList[findIdx].fldAddress1));
                dispatch(createYarnProjectionUserForm('fldSupplierAddress2', supplierList[findIdx].fldAddress2));
                dispatch(createYarnProjectionUserForm('fldSupplierArea', supplierList[findIdx].fldArea));
                dispatch(createYarnProjectionUserForm('fldSupplierCity', supplierList[findIdx].fldCity));
                dispatch(createYarnProjectionUserForm('fldSupplierPincode', supplierList[findIdx].fldPincode));
                dispatch(createYarnProjectionUserForm('fldSupplierGSTNo', supplierList[findIdx].fldGSTNo));

                const currentDate = moment(new Date()).format('YYYY-MM-DD')

                let disableFabricProjection = yarnProjectionList.filter((x) => x.fldPRDate.split('T')[0] === currentDate)


                const lastObject = disableFabricProjection.filter((x) => x.fldSupplierName === supplierList[findIdx].fldName && x.fldFKUnitId == yarnProjectionFormData?.fldFKUnitId);

                setFabricChecker(lastObject)
                if (lastObject?.length > 0) {
                    dispatch(createYarnProjectionUserForm('fldIsFabricProjection', lastObject[0]?.fldIsFabricProjection));
                } else {
                    dispatch(createYarnProjectionUserForm('fldIsFabricProjection', false));
                }
            }



        } else if (key === 'fldFKMillName') {
            // key = name;
            // value = event;
            let findIdx = millName.findIndex((x) => x.fldId === parseInt(value));
            if (findIdx !== -1) {
                dispatch(createYarnProjectionUserForm('fldMillName', millName[findIdx].fldDescription));
            }
        } else if (key === 'fldFKAgentName') {
            // key = name;
            // value = event;
            let findIdx = agentName.findIndex((x) => x.fldId === parseInt(value));
            if (findIdx !== -1) {
                dispatch(createYarnProjectionUserForm('fldAgentName', agentName[findIdx].fldDescription));
            }
        }

        dispatch(createYarnProjectionUserForm(key, value));
    };


    // submit the add state data to database
    const handleSubmit = async (e, formData, inputs) => {
        e.preventDefault();
        let resetRef = reset.current;
        formData['fldEnteredSysId'] = ipAddressInfo?.IPv4 ?? null;
        formData['fldFKYarnType'] = yarnProjectionForm?.fldFKYarnType ?? null;
        formData['fldYarnDescription'] = yarnProjectionForm?.fldYarnDescription ?? null;
        formData['fldFKYarn'] = yarnProjectionForm?.fldFKYarn ?? null;
        formData['fldYarnGroup'] = yarnProjectionForm?.fldYarnGroup ?? null;
        formData['fldFKYarnGroup'] = yarnProjectionForm?.fldFKYarnGroup ?? null;
        formData['fldYarnType'] = yarnProjectionForm?.fldYarnType ?? null;
        formData['fldSupplierName'] = yarnProjectionFormData.fldSupplierName;
        formData['fldSupplierAddress1'] = yarnProjectionFormData.fldSupplierAddress1;
        formData['fldSupplierAddress2'] = yarnProjectionFormData.fldSupplierAddress2;
        formData['fldSupplierArea'] = yarnProjectionFormData.fldSupplierArea;
        formData['fldSupplierCity'] = yarnProjectionFormData.fldSupplierCity;
        formData['fldSupplierPincode'] = yarnProjectionFormData.fldSupplierPincode;
        formData['fldSupplierGSTNo'] = yarnProjectionFormData.fldSupplierGSTNo;
        formData['fldMillName'] = yarnProjectionForm.fldMillName ?? null;
        formData['fldAgentName'] = yarnProjectionForm.fldAgentName ?? null;
        formData['fldIsFabricProjection '] = yarnProjectionForm.fldIsFabricProjection ?? null;
        let currentPrNo = buttonStatus !== 'update' ? prNo?.length > 0 ? prNo[0]?.fldGroupPRNo : 'Auto Generated' : yarnProjectionForm?.fldGroupPRNo

        await dispatch(
            createYarnProjection(
                { ...formData, ...yarnProjectionForm },
                true,
                yarnProjectionForm.fldFKUnitId || yarnProjectionFormData.fldFKUnitId,
                yarnProjectionForm.fldFKSupplierID || yarnProjectionFormData.fldFKSupplierID,
                new Date(fldPRDate),
                currentPrNo,
                combinedSlNo,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                unitId,
                matchingProjection,
                buttonStatus
            )
        );
        dispatch(createYarnProjectionUserForm('fldGroupPRNo', ''));

        resetRef.resetValidationState(true);
    };

    // submit the add new state data to database
    const handleSubmit_addNew = async (e, formData, inputs) => {
        e.preventDefault();
        let resetRef = reset.current;
        formData['fldEnteredSysId'] = ipAddressInfo?.IPv4 ?? null;
        // formData['fldFKYarnType'] = yarnProjectionForm?.fldFKYarnType ?? null;
        // formData['fldYarnDescription'] = yarnProjectionForm?.fldYarnDescription ?? null;
        // formData['fldFKYarn'] = yarnProjectionForm?.fldFKYarn ?? null;
        // formData['fldYarnGroup'] = yarnProjectionForm?.fldYarnGroup ?? null;
        // formData['fldFKYarnGroup'] = yarnProjectionForm?.fldFKYarnGroup ?? null;
        // formData['fldYarnType'] = yarnProjectionForm?.fldYarnType ?? null;

        formData['fldSupplierName'] = yarnProjectionFormData.fldSupplierName;
        formData['fldSupplierAddress1'] = yarnProjectionFormData.fldSupplierAddress1;
        formData['fldSupplierAddress2'] = yarnProjectionFormData.fldSupplierAddress2;
        formData['fldSupplierArea'] = yarnProjectionFormData.fldSupplierArea;
        formData['fldSupplierCity'] = yarnProjectionFormData.fldSupplierCity;
        formData['fldSupplierPincode'] = yarnProjectionFormData.fldSupplierPincode;
        formData['fldSupplierGSTNo'] = yarnProjectionFormData.fldSupplierGSTNo;
        let currentPrNo = buttonStatus !== 'update' ? prNo?.length > 0 ? prNo[0]?.fldGroupPRNo : 'Auto Generated' : yarnProjectionForm?.fldGroupPRNo
        await dispatch(
            createYarnProjection(
                { ...formData, ...yarnProjectionForm },
                false,
                yarnProjectionForm.fldFKUnitId || yarnProjectionFormData.fldFKUnitId,
                yarnProjectionForm.fldFKSupplierID || yarnProjectionFormData.fldFKSupplierID,
                new Date(fldPRDate),
                currentPrNo,
                combinedSlNo,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                unitId,
                matchingProjection,
                buttonStatus
            )
        );
        resetRef.resetValidationState(true);
        setAddNewOption('addNew');
    };

    // update state to database
    const handleUpdate = async (e, formData, inputs) => {
        e.preventDefault();
        let resetRef = reset.current;
        formData['fldEnteredSysId'] = ipAddressInfo?.IPv4 ?? null;
        formData['fldGroupPRNo'] = yarnProjectionForm.fldGroupPRNo ?? null;

        // formData['fldFKYarnType'] = yarnProjectionForm?.fldFKYarnType ?? null;
        // formData['fldYarnDescription'] = yarnProjectionForm?.fldYarnDescription ?? null;
        // formData['fldFKYarn'] = yarnProjectionForm?.fldFKYarn ?? null;
        // formData['fldYarnGroup'] = yarnProjectionForm?.fldYarnGroup ?? null;
        // formData['fldFKYarnGroup'] = yarnProjectionForm?.fldFKYarnGroup ?? null;
        // formData['fldYarnType'] = yarnProjectionForm?.fldYarnType ?? null;
        // formData['fldSupplierName'] = yarnProjectionForm.fldSupplierName ?? null;
        await dispatch(
            updateYarnProjection(
                { ...yarnProjectionForm, ...formData },
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'),
                unitId,
            )
        );
        resetRef.resetValidationState(true);
    };
    console.log("Yarnojk", yarnProjectionOverAllReport)
    const handleErrorSubmit = (e, formData, errorInputs) => {
        //console.log(errorInputs);
    };
    const selectSubmitOption = async (e, formData, inputs) => {
        e.preventDefault();
        const submitAction = e?.nativeEvent?.submitter?.name;
        setAddNewOption(submitAction);

        if (submitAction === 'addNew') {
            handleSubmit_addNew(e, formData, inputs);
        } else if (buttonStatus === 'create') {
            handleSubmit(e, formData, inputs);
        } else if (buttonStatus === 'update') {
            handleUpdate(e, formData, inputs);
        } else if (buttonStatus === 'delete') {
            dispatch(deleteYarnProjection(yarnProjectionForm?.fldId,
                moment(startDate).format('YYYY-MM-DD'),
                moment(endDate).format('YYYY-MM-DD'), unitId));
        }
    };
    // const selectSubmitOption = async (e, formData, inputs) => {
    //     e.preventDefault();
    //     setaddnew(e?.nativeEvent?.submitter?.name);
    //     if (e?.nativeEvent?.submitter?.name === 'addNew') {
    //         handleSubmit_addNew(e, formData, inputs);
    //     } else if (buttonStatus === 'create') {
    //         handleSubmit(e, formData, inputs);
    //     } else if (buttonStatus === 'update') {
    //         handleUpdate(e, formData, inputs);
    //     } else if (buttonStatus === 'delete') {
    //         dispatch(
    //             deleteYarnProjection(yarnProjectionForm?.fldId),
    //             moment(startDate).format('YYYY-MM-DD'),
    //             moment(endDate).format('YYYY-MM-DD'),
    //             unitId
    //         );
    //     }
    // };


    const propertyModal = (status) => {
        dispatch({ type: PROPERTY_MODAL_OPEN, id: componentId });
        switch (status) {
            case 'yarnMaterial':
                setSelectedList('yarnMaterial');
                apiCallId = 80;
                break;
            default:
                break;
        }
    };
    const invoiceClick = (e) => {
        history.push({
            pathname: '/yarn-projection/YarnProjectionInvoice',
            state: {
                //id: e.row.data.fldId
                unitId: e.row.data.fldFKUnitId,
                supplierId: e.row.data.fldFKSupplierID,
                prDate: e.row.data.fldPRDate,
                fldGroupPRNo: e.row.data.fldGroupPRNo,
                fldIsFabricProjection: e.row.data.fldIsFabricProjection
            }
        });
    };

    const editClick = (e) => {
        dispatch({ type: MODAL_OPEN });
        dispatch({ type: UPDATE_BUTTON });
        dispatch(getSingleYarnProjection(e.row.data));
    };
    const deleteClick = (e) => {
        dispatch({ type: MODAL_OPEN });
        dispatch({ type: DELETE_BUTTON });
        dispatch(getSingleYarnProjection(e.row.data));
    };
    const onExporting = useCallback((e) => {
        if (e.format === 'xlsx') {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Yarn Projection');
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'YarnProjection.xlsx');
                });
            });
            e.cancel = true;
        } else if (e.format === 'pdf') {
            const doc = new jsPDF();
            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: e.component
            }).then(() => {
                doc.save('YarnProjection.pdf');
            });
        }
    });
    const allowedPageSizes = [10, 20, 50, 100];
    const renderTitleHeader = (data) => {
        return <div style={{ fontWeight: 'bold' }}>{data.column.caption}</div>;
    };

    const getLastAddedDetail = () => {
        if (yarnProjectionList && yarnProjectionList.length > 0) {
            // const sortedList = [...yarnProjectionList].sort((a, b) => new Date(b.fldPRDate) - new Date(a.fldPRDate));
            const sortedList = [...yarnProjectionList].sort((a, b) => {
                const dateA = new Date(a.fldPRDate);
                const dateB = new Date(b.fldPRDate);

                if (dateA.getTime() !== dateB.getTime()) {
                    return dateB - dateA; // Sort by date descending
                } else {
                    return b.fldId - a.fldId; // If dates are the same, sort by ID descending
                }
            });
            return sortedList[0];
        }
        return null;
    };



    useEffect(() => {
        let defaultText = `We are confirming the ${yarnProjectionForm.fldIsFabricProjection ? 'fabric' : 'yarn'} bag requirement for the month of ${moment().format('MMM-YYYY')}, and will share the ${yarnProjectionForm.fldIsFabricProjection ? 'Fabric PO' : 'Yarn PO'} for the same shortly.`;
        setFldBody(defaultText)
    }, [yarnProjectionForm.fldIsFabricProjection])

    useEffect(() => {
        if (isReportScreen && isOverAll == true) {
            dispatch(fetchYarnProjectionOverAllReports())
        }

    }, [isOverAll, isReportScreen])

    const [subject, setSubject] = useState(yarnProjectionForm?.fldSubject || '');

    // Handle change in the TextInput
    const handleSubjectChange = (event) => {
        const newSubject = event.target.value;
        setSubject(newSubject);
        handleChange({ target: { name: 'fldSubject', value: newSubject } });
    };

    const [fldBody, setFldBody] = useState(yarnProjectionForm?.fldBody);


    // Handle the change event for the TextInput
    const handleTextInputChange = (e) => {
        setFldBody(e.target.value);
        handleChange(e); // If handleChange is meant to handle form updates
    };

    const yarnOptions = yarnMasterList.map((item) => ({
        key: item.fldId,
        value: item.fldId,
        label: item.fldDescription
    }));

    const [date, setDate] = useState(new Date());

    const formatMonthYear = (date) => {
        const year = date.getFullYear().toString().slice(-2); // last 2 digits of year
        const month = String(date.getMonth() + 1).padStart(2, "0"); // ensure 2 digits
        return year + month;
    };

    const prDate = yarnProjectionForm?.fldPRDate
        ? new Date(yarnProjectionForm.fldPRDate)
        : new Date();

    return (
        <Row className="d-flex flex-column">

            {/* <label>Select Month & Year: </label>
            <DatePicker
                selected={date}
                onChange={(d) => setDate(d)}
                dateFormat="MM/yyyy"
                showMonthYearPicker
            /> */}
            {/* <p>Selected: {date.toLocaleDateString("en-US", { month: "long", year: "numeric" })}</p> */}

            {loading && <Loader />}

            <CommonPropertyModal
                //  apiCall={apiCallId == 80 ? fetchCommonPropertyById(apiCallId) : fetchPropertyDataForFabricInfo(apiCallId)}
                apiCallId={apiCallId}
                id={componentId}
                itemList={selectedList === 'yarnMaterial' ? yarnMaterial : []}
            />
            <CommonFeedbackModal id={componentId} />
            <Col>
                {!isReportScreen && <button className="addBtnPosition btn btn-primary" onClick={() => commonOpenModalActions()}>
                    <span className="plusAdd">+</span>
                    <span className="addAdd">ADD</span>
                </button>}

                <Card>
                    <Modal
                        centered
                        show={isFormModal}
                        size="lg"
                        onHide={() => {
                            dispatch({ type: MODAL_CLOSE });
                            dispatch({ type: RESET_YARN_PROJECTION_INFO });
                        }}
                        backdrop="static"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title as="h5">
                                {buttonStatus === 'create'
                                    ? 'Create Yarn Projection'
                                    : buttonStatus === 'update'
                                        ? 'Update Yarn Projection'
                                        : buttonStatus === 'delete' && 'Delete Yarn Projection'}
                            </Modal.Title>
                            <OverlayTrigger
                                className="tooltip"
                                delay={{ hide: 450, show: 200 }}
                                overlay={(props) => <Tooltip {...props}>Add Feedback</Tooltip>}
                                placement="bottom"
                            >
                                <div className="anywhereFeedback">
                                    <i
                                        className="fa fa-comments feedbackWithFill"
                                        onClick={() => dispatch({ type: FEEDBACK_MODAL_OPEN, id: componentId })}
                                        style={{ color: 'purple', cursor: 'pointer', fontSize: '18px' }}
                                    ></i>
                                    <i
                                        className="fa fa-comments-o feedbackWithoutFill"
                                        onClick={() => dispatch({ type: FEEDBACK_MODAL_OPEN, id: componentId })}
                                        style={{ color: 'purple', cursor: 'pointer', fontSize: '18px' }}
                                    ></i>
                                </div>
                            </OverlayTrigger>
                        </Modal.Header>
                        <Modal.Body>
                            <ValidationForm ref={reset} onSubmit={selectSubmitOption} onErrorSubmit={handleErrorSubmit}>
                                <Form.Row>
                                    {addNewOption === 'addNew' && (
                                        <Form.Group as={Col} md="4">
                                            <Form.Label htmlFor="fldFKUnitId">
                                                Unit ID<span className="text-danger">*</span>
                                            </Form.Label>
                                            <SelectGroup
                                                name="fldFKUnitId"
                                                id="fldFKUnitId"
                                                value={yarnProjectionFormData?.fldFKUnitId}
                                                required={!yarnProjectionFormData?.fldFKUnitId && true}

                                                disabled={addNewOption === 'addNew' || buttonStatus === 'update' || buttonStatus === 'delete'}
                                                errorMessage="Please select unit id."
                                                onChange={handleChange}
                                            >
                                                <option value="">Please select</option>
                                                {unitMaster.length > 0 &&
                                                    unitMaster.map((item) => {
                                                        return (
                                                            <option key={item?.fldId} value={item.fldId}>
                                                                {item.fldName} - {item?.tblPropertiesunit?.fldDescription}
                                                            </option>
                                                        );
                                                    })}
                                            </SelectGroup>
                                        </Form.Group>
                                    )}
                                    {addNewOption === 'addNew' && (
                                        <Form.Group as={Col} md="4">
                                            <Form.Label htmlFor="fldFKSupplierID">
                                                Supplier ID
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <SelectGroup
                                                name="fldFKSupplierID"
                                                id="fldFKSupplierID"
                                                value={yarnProjectionFormData?.fldFKSupplierID}
                                                required={!yarnProjectionFormData?.fldFKSupplierID && true}
                                                // onClick={() => buttonStatus === 'update' && dispatch(fetchYarnPOSupplierDropdown('TblFabricPO'))}
                                                // disabled={buttonStatus === 'delete' && true}
                                                disabled={addNewOption === 'addNew' || buttonStatus === 'update' || buttonStatus === 'delete'}
                                                errorMessage={'Please select supplier ID.'}
                                                //onChange={handleSupplierSelection}// supplier id based grid view
                                                onChange={handleChange}
                                            >
                                                <option value="">Please select</option>
                                                {supplierList.length > 0 &&
                                                    supplierList.map((item) => {
                                                        return <option key={item?.fldId} value={item.fldId}>{item.fldName}</option>;
                                                    })}
                                            </SelectGroup>
                                        </Form.Group>
                                    )}
                                    {addNewOption !== 'addNew' && (
                                        <Form.Group as={Col} md="4">
                                            <Form.Label htmlFor="fldFKUnitId">
                                                Unit ID<span className="text-danger">*</span>
                                            </Form.Label>
                                            <SelectGroup
                                                name="fldFKUnitId"
                                                id="fldFKUnitId"
                                                value={yarnProjectionForm?.fldFKUnitId}
                                                required={!yarnProjectionForm?.fldFKUnitId && true}

                                                disabled={buttonStatus === 'update' || buttonStatus === 'delete' && true}
                                                errorMessage="Please select unit id."
                                                onChange={handleChange}
                                            >
                                                <option value="">Please select</option>
                                                {unitMaster.length > 0 &&
                                                    unitMaster.map((item) => {
                                                        return (
                                                            <option key={item?.fldId} value={item.fldId}>
                                                                {item.fldName} - {item?.tblPropertiesunit?.fldDescription}
                                                            </option>
                                                        );
                                                    })}
                                            </SelectGroup>
                                        </Form.Group>
                                    )}
                                    {addNewOption !== 'addNew' && (
                                        <Form.Group as={Col} md="4">
                                            <Form.Label htmlFor="fldFKSupplierID">
                                                Supplier ID
                                                <span className="text-danger">*</span>
                                            </Form.Label>
                                            <SelectGroup
                                                name="fldFKSupplierID"
                                                id="fldFKSupplierID"
                                                value={yarnProjectionForm?.fldFKSupplierID}
                                                required={!yarnProjectionForm?.fldFKSupplierID && true}
                                                // onClick={() => buttonStatus === 'update' && dispatch(fetchYarnPOSupplierDropdown('TblFabricPO'))}
                                                disabled={buttonStatus === 'update' || buttonStatus === 'delete' && true}
                                                errorMessage={'Please select supplier ID.'}
                                                //onChange={handleSupplierSelection}// supplier id based grid view
                                                onChange={handleChange}
                                            >
                                                <option value="">Please select</option>
                                                {supplierList.length > 0 &&
                                                    supplierList.map((item) => {
                                                        return <option key={item?.fldId} value={item.fldId}>{item.fldName}</option>;
                                                    })}
                                            </SelectGroup>
                                        </Form.Group>
                                    )}
                                    {/* {(addNewOption === 'addNew' || addNewOption !== 'addNew') && (
                                        <Form.Group as={Col} md="4">
                                            <Form.Label htmlFor="fldFKUnitId">
                                                Unit ID<span className="text-danger">*</span>
                                            </Form.Label>
                                            <SelectGroup
                                                name="fldFKUnitId"
                                                id="fldFKUnitId"
                                                value={yarnProjectionFormData?.fldFKUnitId || yarnProjectionForm?.fldFKUnitId}
                                                required={!yarnProjectionFormData?.fldFKUnitId && true}
                                                onClick={(e) => dispatch(fetchYarnPOSectionDropdown(e.target.value))}
                                                disabled={addNewOption === 'addNew' || buttonStatus === 'delete'}
                                                errorMessage="Please select unit id."
                                                onChange={handleChange}
                                            >
                                                <option value="">Please select</option>
                                                {unitMaster.length > 0 &&
                                                    unitMaster.map((item) => (
                                                        <option key={item.fldId} value={item.fldId}>
                                                            {item.fldName} - {item?.tblPropertiesunit?.fldDescription}
                                                        </option>
                                                    ))}
                                            </SelectGroup>
                                        </Form.Group>
                                    )}
                                   
                                    {(addNewOption === 'addNew' || addNewOption !== 'addNew') && (
                                        <Form.Group as={Col} md="4">
                                            <Form.Label htmlFor="fldFKSupplierID">
                                                Supplier ID<span className="text-danger">*</span>
                                            </Form.Label>
                                            <SelectGroup
                                                name="fldFKSupplierID"
                                                id="fldFKSupplierID"
                                                value={yarnProjectionFormData?.fldFKSupplierID || yarnProjectionForm?.fldFKSupplierID}
                                                required={!yarnProjectionFormData?.fldFKSupplierID && true}
                                                disabled={addNewOption === 'addNew' || buttonStatus === 'delete'}
                                                errorMessage="Please select supplier ID."
                                                onChange={handleChange}
                                            >
                                                <option value="">Please select</option>
                                                {supplierList.length > 0 &&
                                                    supplierList.map((item) => (
                                                        <option key={item.fldId} value={item.fldId}>
                                                            {item.fldName}
                                                        </option>
                                                    ))}
                                            </SelectGroup>
                                        </Form.Group>
                                    )} */}
                                    <Form.Group as={Col} md="4"></Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldGroupPRNo">
                                            PR No.<span className="text-danger">*</span>
                                        </Form.Label>

                                        <TextInput
                                            name="fldGroupPRNo"
                                            id="fldGroupPRNo"
                                            placeholder="Please Enter PR No."
                                            pattern="^[A-Za-z0-9 ]+$"
                                            errorMessage={{ pattern: 'No special characters are allowed' }}
                                            disabled
                                            value={buttonStatus == 'create' ? prNo?.length > 0 ? prNo[0]?.fldGroupPRNo : 'Auto Generated' : yarnProjectionForm?.fldGroupPRNo}
                                            // value={yarnProjectionForm?.fldGroupPRNo || 'Auto Generated'}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />

                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldPRDate">
                                            PR Date<span className="text-danger">*</span>
                                        </Form.Label>
                                        <ReactDatePicker
                                            // style={{ width: '100%' }}
                                            name="fldPRDate"
                                            id="fldPRDate"
                                            disabled={true}
                                            required
                                            minDate={new Date()}
                                            // maxDate={new Date(singleSalesOrderData?.fldLastDeliveryDate)}
                                            dateFormat="dd/MMM/yy"
                                            selected={prDate}
                                            // selected={new Date(yarnProjectionForm?.fldDeliveryDate) ?? new Date()}
                                            // onChange={(e) => handleChange(e, 'fldPRDate')}
                                            onChange={(date) => {
                                                setFldPRDate(date);
                                                handleChange({ target: { value: date } }, 'fldPRDate');
                                            }}
                                            className="form-control"
                                            isClearable={false}
                                            placeholderText="DD-MMM-YY"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldGroupPRNo" style={{ visibility: 'hidden' }}>
                                            Existing PR No<span className="text-danger">*</span>
                                        </Form.Label>
                                        <TextInput
                                            name="fldGroupPRNo"
                                            id="fldGroupPRNo"
                                            placeholder="Auto Generated"
                                            value={displayValue}
                                            onChange={handleChange}
                                            autoComplete="off"
                                            disabled // Optional, depends on if you want the input to be editable
                                            style={{ visibility: 'hidden' }}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldCombinedSlNo">
                                            Combined SlNo.<span className="text-danger">*</span>
                                        </Form.Label>
                                        <TextInput
                                            name="fldCombinedSlNo"
                                            id="fldCombinedSlNo"
                                            placeholder="Please Enter Combined Sl No."
                                            pattern="^[A-Za-z0-9 ]+$"
                                            errorMessage={{
                                                pattern: 'No special characters are allowed'
                                            }}
                                            //disabled={true}
                                            value={yarnProjectionForm?.fldCombinedSlNo || combinedSlNo}
                                            // value={combinedSlNo || yarnProjectionForm?.fldCombinedSlNo || '' }
                                            onChange={(e) => handleChange(e, 'fldCombinedSlNo')}
                                            autoComplete="off"
                                        />
                                        {/* <SelectGroup
                                            name="fldCombinedSlNo"
                                            id="fldCombinedSlNo"
                                            value={yarnProjectionForm?.fldCombinedSlNo}
                                          //  required={!yarnProjectionForm?.fldGroupPRNo && true}
                                            onClick={() =>  dispatch(fetchCombinedSlNo(yarnProjectionForm?.fldGroupPRNo))}
                                           // disabled
                                           // errorMessage={'Please select supplier ID.'}
                                            //onChange={handleSupplierSelection}// supplier id based grid view
                                            onChange={handleChange}
                                        >
                                            <option value="">Please select</option>
                                            {combinedSlNo.length > 0 &&
                                                combinedSlNo.map((item) => {
                                                    return <option value={item}>{item}</option>;
                                                })}
                                        </SelectGroup> */}
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldFKMillName">
                                            Mill Name<span className="text-danger">*</span>
                                        </Form.Label>
                                        <SelectGroup
                                            name="fldFKMillName"
                                            id="fldFKMillName"
                                            value={yarnProjectionForm?.fldFKMillName}
                                            required={!yarnProjectionForm?.fldFKMillName && true}
                                            disabled={buttonStatus === 'delete' && true}
                                            errorMessage="Please select mill name."
                                            onClick={() => buttonStatus === 'update' && dispatch(fetchCommonPropertyById(58))}
                                            onChange={(e) => handleChange(e, 'fldFKMillName')}
                                        >
                                            {millName && (millName.length === 0 || millName.length > 1) && (
                                                <option value="">Please select</option>
                                            )}
                                            {millName &&
                                                millName.length > 0 &&
                                                millName.map((item) => {
                                                    return (
                                                        <option value={item?.fldId} key={item?.fldId}>
                                                            {item?.fldDescription}
                                                        </option>
                                                    );
                                                })}
                                        </SelectGroup>
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldFKAgentName">
                                            Agent Name<span className="text-danger">*</span>
                                        </Form.Label>
                                        <SelectGroup
                                            name="fldFKAgentName"
                                            id="fldFKAgentName"
                                            value={yarnProjectionForm?.fldFKAgentName}
                                            required={!yarnProjectionForm?.fldFKAgentName && true}
                                            disabled={buttonStatus === 'delete' && true}
                                            errorMessage="Please select agent name."
                                            onClick={() => buttonStatus === 'update' && dispatch(fetchCommonPropertyById(57))}
                                            onChange={(e) => handleChange(e, 'fldFKAgentName')}
                                        >
                                            {agentName && (agentName.length === 0 || agentName.length > 1) && (
                                                <option value="">Please select</option>
                                            )}
                                            {agentName &&
                                                agentName.length > 0 &&
                                                agentName.map((item) => {
                                                    return (
                                                        <option value={item?.fldId} key={item?.fldId}>
                                                            {item?.fldDescription}
                                                        </option>
                                                    );
                                                })}
                                        </SelectGroup>
                                    </Form.Group>
                                    {/*Yarn Material*/}
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldFKYarn">
                                            Yarn <span className="text-danger">*</span>
                                        </Form.Label>
                                        {/* <Select
                                            name="fldFKYarn"
                                            id="fldFKYarn"
                                            value={selectedOption}
                                            onChange={(selectedOption) => {
                                                handleChange({ target: { name: 'fldFKYarn', value: selectedOption?.value } });
                                            }}
                                            options={options}
                                            isDisabled={buttonStatus === 'delete'}
                                            placeholder="Please select"
                                            required
                                            noOptionsMessage={() => 'No options available'}
                                        /> */}
                                        <Select
                                            name="fldFKYarn"
                                            id="fldFKYarn"
                                            value={yarnOptions.filter((option) => option.value === yarnProjectionForm?.fldFKYarn)}
                                            isDisabled={buttonStatus === 'delete'}
                                            placeholder="Please select"
                                            isSearchable
                                            isClearable
                                            options={yarnOptions}
                                            onChange={(selectedOption) => {
                                                handleChange({
                                                    target: {
                                                        name: 'fldFKYarn',
                                                        value: selectedOption.value
                                                    }
                                                });
                                                if (buttonStatus === 'update') {
                                                    dispatch(fetchYarnMasterDataDetails());
                                                }
                                            }}
                                        />
                                        {/* <SelectGroup
                                            name="fldFKYarn"
                                            id="fldFKYarn"
                                            value={yarnProjectionForm?.fldFKYarn}
                                            required
                                            disabled={buttonStatus === 'delete' && true}
                                            errorMessage="Please select a Yarn "
                                            onClick={() => buttonStatus === 'update' && dispatch(fetchYarnMasterDataDetails())}
                                            onChange={handleChange}
                                        >
                                            <option value="">Please select</option>
                                            {yarnMasterList.length > 0 &&
                                                yarnMasterList.map((item) => {
                                                    return (
                                                        <option value={item.fldId} key={item.fldId}>
                                                            {item.fldDescription}
                                                        </option>
                                                    );
                                                })}
                                        </SelectGroup> */}
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldBagWeight">
                                            Bags Weight (Kgs)<span className="text-danger">*</span>
                                        </Form.Label>
                                        <TextInput
                                            name="fldBagWeight"
                                            id="fldBagWeight"
                                            placeholder="Please enter Bags Weight."
                                            disabled={buttonStatus === 'delete' && true}
                                            pattern="^\d+(\.\d{1,2})?$"
                                            errorMessage={{
                                                pattern: '*Only Numbers and Decimal values allowed.'
                                            }}
                                            style={{ textAlign: 'right' }}
                                            required
                                            value={yarnProjectionForm?.fldBagWeight}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldNoofBags">
                                            No of bags<span className="text-danger">*</span>
                                        </Form.Label>
                                        <TextInput
                                            name="fldNoofBags"
                                            id="fldNoofBags"
                                            placeholder="Please enter No of bags."
                                            disabled={buttonStatus === 'delete' && true}
                                            pattern="^[A-Za-z0-9 ]+$"
                                            errorMessage={{
                                                pattern: 'No special characters / space are allowed'
                                            }}
                                            style={{ textAlign: 'right' }}
                                            required
                                            value={yarnProjectionForm?.fldNoofBags}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <Form.Label htmlFor="fldPRWeight">Total Weight (kgs)</Form.Label>
                                        <TextInput
                                            name="fldPRWeight"
                                            id="fldPRWeight"
                                            placeholder="Please enter your Quantity"
                                            disabled
                                            pattern="^\d+(\.\d{1,2})?$"
                                            errorMessage={{
                                                pattern: '*Only Numbers and Decimal values allowed.'
                                            }}
                                            style={{ textAlign: 'right' }}
                                            required
                                            // value={
                                            //     yarnProjectionForm?.fldPRWeight
                                            //         ? Number(yarnProjectionForm?.fldPRWeight).toFixed(2)
                                            //         : '0.00'
                                            // }
                                            value={Number(calculateValue('fldPRWeight')).toFixed(2)}
                                            onChange={(e) => handleChange(e, 'fldPRWeight')}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="4">
                                        <div style={{ display: 'flex' }}>
                                            <div>
                                                <Form.Check
                                                    type="checkbox"
                                                    id="FldIsExMillRate"
                                                    label="Ex Mill Rate"
                                                    checked={yarnProjectionForm?.FldIsExMillRate || false}
                                                    onChange={(e) => handleRateCheckboxChange(e)}
                                                />
                                            </div>
                                            <div style={{ marginLeft: '20px' }}>

                                                <Form.Check
                                                    disabled={fabricChecker?.length > 0 && buttonStatus === 'create' || buttonStatus === 'update'}
                                                    type="checkbox"
                                                    id="fldIsFabricProjection"
                                                    label="Fabric Projection"
                                                    checked={yarnProjectionForm?.fldIsFabricProjection || false}
                                                    onChange={(e) => {
                                                        dispatch(createYarnProjectionUserForm('fldIsFabricProjection', e.target.checked));
                                                    }}
                                                />
                                            </div>

                                        </div>
                                        <Form.Label htmlFor="fldRate">
                                            Rate per Kg<span className="text-danger">*</span>
                                        </Form.Label>
                                        <TextInput
                                            name="fldRate"
                                            id="fldRate"
                                            placeholder="Please enter your Rate"
                                            disabled={buttonStatus === 'delete' && true}
                                            pattern="^\d+(\.\d{1,3})?$"
                                            errorMessage={{
                                                pattern: '*Only Numbers and Decimal values allowed.'
                                            }}
                                            style={{ textAlign: 'right' }}
                                            required
                                            value={yarnProjectionForm?.fldRate}
                                            onChange={(e) => handleChange(e, 'fldRate')}
                                            autoComplete="off"
                                        />
                                    </Form.Group>


                                    {/* <Form.Group as={Col} md="12">
                                        <hr />
                                    </Form.Group> */}
                                    <Form.Group as={Col} md="12">
                                        <Form.Label htmlFor="fldSubject">Subject</Form.Label>
                                        {/* <Checkbox checked={isSubjectEditable} onChange={handleCheckboxSubjectChange} /> // subject validations 0407*/}
                                        <TextInput
                                            multiline
                                            rows="1"
                                            name="fldSubject"
                                            id="fldSubject"
                                            placeholder="Please enter Subject"
                                            pattern="^[A-Za-z0-9 ]+$"
                                            maxLength="100"
                                            errorMessage={{
                                                pattern: 'No special characters are allowed'
                                            }}
                                            disabled={buttonStatus === 'delete' && true}
                                            //value={subject}
                                            value={buttonStatus === 'update' ? yarnProjectionForm?.fldSubject : subject}
                                            onChange={handleSubjectChange}
                                            //value={yarnProjectionForm?.fldSubject}
                                            // onChange={handleChange}
                                            //value={yarnProjectionForm?.fldSubject || fldSubject } // Ensure this value is from the Redux store
                                            //// subject validations 0407
                                            // disabled={!isSubjectEditable}
                                            // value={subjectValue}
                                            // onChange={handleSubjectChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="12">
                                        <Form.Label htmlFor="fldBody">Body of the letter</Form.Label>
                                        <TextInput
                                            multiline
                                            rows="4"
                                            name="fldBody"
                                            id="fldBody"
                                            placeholder="Please enter Body of the Letter"
                                            pattern="^[A-Za-z0-9 ]+$"
                                            errorMessage={{
                                                pattern: 'No special characters are allowed'
                                            }}
                                            disabled={buttonStatus === 'delete' && true}
                                            //value={yarnProjectionForm?.fldBody || defaultText}
                                            //onChange={handleChange}
                                            value={fldBody}
                                            onChange={handleTextInputChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} md="12">
                                        <Form.Label htmlFor="fldRemarks">Remark</Form.Label>
                                        <TextInput
                                            multiline
                                            rows="1"
                                            name="fldRemarks"
                                            id="fldRemarks"
                                            placeholder="Please enter Remark"
                                            pattern="^[A-Za-z0-9 ]+$"
                                            errorMessage={{
                                                pattern: 'No special characters are allowed'
                                            }}
                                            disabled={buttonStatus === 'delete' && true}
                                            value={yarnProjectionForm?.fldRemarks}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </Form.Group>
                                    <div className="col-12">
                                        <Form.Group as={Col} md="12">
                                            <Form.Check type="checkbox" label="Display Previous Set Info" onChange={handleCheckboxChange} />
                                            {showGrid && (
                                                <Card.Body>
                                                    <DataGrid
                                                        dataSource={prNo}
                                                        keyExpr="fldId"
                                                        showBorders={true}
                                                        columnAutoWidth={true}
                                                        allowColumnReordering={true}
                                                        rowAlternationEnabled={true}
                                                        // onExporting={onExporting}
                                                        hoverStateEnabled={true}
                                                        allowColumnResizing={true}
                                                        columnResizingMode="widget"
                                                    >
                                                        <FilterRow visible={true} applyFilter="auto" />
                                                        <FilterPanel visible={true} />
                                                        <HeaderFilter visible={true} />
                                                        {/* <SearchPanel visible={true} width={240} placeholder="Search..." />
                                                        a<ColumnChooser enabled={true} /> */}
                                                        <ColumnFixing enabled={true} />
                                                        <Scrolling rowRenderingMode="virtual"></Scrolling>
                                                        <Paging defaultPageSize={10} />
                                                        <Pager
                                                            visible={true}
                                                            showPageSizeSelector={true}
                                                            allowedPageSizes={allowedPageSizes}
                                                            showNavigationButtons={true}
                                                            showInfo={true}
                                                            infoText="Page #{0}. Total: {1} ({2} items)"
                                                        />
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            fixed={true}
                                                            dataField="fldGroupPRNo"
                                                            caption="PR No"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataType="date"
                                                            format="dd-MMM-yy"
                                                            dataField="fldPRDate"
                                                            caption="PR Date"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldCombinedSlNo"
                                                            caption="Combined SlNo"
                                                        ></Column>
                                                        {/* <Column
                                                    headerCellRender={renderTitleHeader}
                                                    fixed={true}
                                                    dataField="tblPropertyYarnGroup.fldDescription"
                                                    caption="Yarn Group"
                                                ></Column>
                                                <Column
                                                    headerCellRender={renderTitleHeader}
                                                    dataField="tblPropertyYarnType.fldDescription"
                                                    caption="Yarn Type"
                                                ></Column> */}
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldSupplierName"
                                                            caption="Supplier Name"
                                                        ></Column>

                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldMillName"
                                                            caption="Mill Name"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldAgentName"
                                                            caption="Agent Name"
                                                        ></Column>

                                                        {/* <Column headerCellRender={renderTitleHeader} dataField="fldColor" caption="Color"></Column> */}
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldYarnDescription"
                                                            caption="Yarn Description"
                                                        ></Column>

                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldBagWeight"
                                                            caption="Bag Weight(Kg)"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldNoofBags"
                                                            caption="No of Bags"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldRate"
                                                            caption="Rate"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldPRWeight"
                                                            caption="PR Weight(Kg)"
                                                        ></Column>
                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldSubject"
                                                            caption="Subject"
                                                        ></Column>

                                                        <Column
                                                            headerCellRender={renderTitleHeader}
                                                            dataField="fldRemarks"
                                                            caption="Remarks"
                                                        ></Column>

                                                        {/* <Column headerCellRender={renderTitleHeader} caption="Actions" type="buttons" width={110}>
                                                    <ActionButton text="Edit" icon="edit" hint="Edit" onClick={editClick} />
                                                    <ActionButton
                                                        cssClass="text-danger"
                                                        id="deleteButton"
                                                        text="Delete"
                                                        icon="trash"
                                                        hint="Call Off"
                                                        onClick={deleteClick}
                                                    />
                                                </Column> */}
                                                        <Summary>
                                                            <TotalItem column="fldDescription" summaryType="count" />
                                                        </Summary>
                                                        <Export formats={exportFormats} enabled={true} allowExportSelectedData={true} />
                                                    </DataGrid>
                                                </Card.Body>
                                            )}
                                        </Form.Group>
                                    </div>{' '}
                                    <Form.Group as={Col} sm={12} className="d-flex justify-content-around">
                                        <Button
                                            variant="secondary"
                                            onClick={() => {
                                                dispatch({ type: RESET_YARN_PROJECTION_INFO });
                                                dispatch({ type: MODAL_CLOSE });
                                            }}
                                        >
                                            Close
                                        </Button>
                                        {buttonStatus === 'create' && (
                                            <>
                                                <Button type="submit" variant="primary" name="addNew" value="addNew">
                                                    Save & Add New
                                                </Button>
                                                <Button variant="info" type="submit" name="Create" value="Create">
                                                    Save & Close
                                                </Button>
                                            </>
                                        )}
                                        {buttonStatus === 'update' && (
                                            <Button variant="info" type="submit" name="Update" value="Update">
                                                Update
                                            </Button>
                                        )}
                                        {buttonStatus === 'delete' && (
                                            <>
                                                <Button variant="danger" type="submit" name="Delete" value="Delete">
                                                    Delete
                                                </Button>
                                                <Button variant="info" onClick={() => dispatch({ type: UPDATE_BUTTON })}>
                                                    Go To Edit
                                                </Button>
                                            </>
                                        )}
                                    </Form.Group>
                                </Form.Row>


                            </ValidationForm>
                        </Modal.Body>
                    </Modal>
                    <Card.Body>
                        {!isReportScreen ?
                            <>
                                <Form.Row>
                                    <Form.Group as={Col} md="3" className="d-flex flex-row justify-content-around align-items-center">
                                        <Form.Label htmlFor="fldRemarks">
                                            From Date<span className="text-danger">*</span>
                                        </Form.Label>
                                        <div style={{ width: '80%', }}>
                                            <ReactDatePicker
                                                // disabled={buttonStatus === 'delete' && true}
                                                name="fldStartDate"
                                                id="fldStartDate"
                                                required
                                                dateFormat="yyyy-MM-dd"
                                                selected={startDate}
                                                onChange={setStartDate}
                                                className="form-control"
                                                placeholderText="From Date"
                                            // minDate={new Date()}
                                            />
                                        </div>
                                    </Form.Group>
                                    <Form.Group as={Col} md="3" className="d-flex flex-row justify-content-between align-items-center">
                                        <Form.Label htmlFor="fldRemarks">
                                            To Date<span className="text-danger">*</span>
                                        </Form.Label>
                                        <div style={{ width: '80%', }}>
                                            <ReactDatePicker
                                                // disabled={buttonStatus === 'delete' && true}
                                                name="fldEndDate"
                                                id="fldEndDate"
                                                required
                                                dateFormat="yyyy-MM-dd"
                                                selected={endDate}
                                                onChange={setEndDate}
                                                className="form-control"
                                                placeholderText="To Date"
                                            // minDate={new Date()}
                                            />
                                        </div>
                                    </Form.Group>
                                    <Form.Group as={Col} md="2">
                                        <Button
                                            size="sm"
                                            variant="primary"
                                            type="submit"
                                            name="refresh"
                                            value="refresh"
                                            onClick={() =>
                                                dispatch(
                                                    fetchYarnProjection(
                                                        moment(startDate).format('YYYY-MM-DD'),
                                                        moment(endDate).format('YYYY-MM-DD'),
                                                        unitId
                                                    )
                                                )
                                            }
                                        >
                                            Refresh
                                        </Button>
                                    </Form.Group>
                                </Form.Row>
                            </>
                            : <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>

                                    <label style={{ fontWeight: 'bold' }}>Select Month & Year: </label>
                                    <DatePicker
                                        selected={date}
                                        onChange={(d) => {
                                            setDate(d)
                                        }}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                        popperClassName="datepicker-popper"
                                        disabled={isOverAll == true}
                                    />
                                </div>
                                <div>
                                    <Form.Check
                                        type='checkbox'
                                        name='fldIsOverall'
                                        label='OverAllReport'
                                        checked={isOverAll}
                                        value={isOverAll}
                                        onChange={(e) => setIsOverAll(e.target.checked)}
                                        style={{ fontWeight: 'bold', marginRight: '10px' }}
                                    />
                                </div>
                                <div>
                                    <Button
                                        size="sm"
                                        variant="primary"
                                        type="submit"
                                        name="refresh"
                                        value="refresh"
                                        onClick={() => {
                                            let finalDate = formatMonthYear(date)
                                            dispatch(
                                                fetchYarnProjectionReports(finalDate)
                                            )
                                        }

                                        }
                                    >
                                        Search
                                    </Button>
                                </div>
                            </div>}
                        <div >

                            {isReportScreen && <DataGrid
                                dataSource={isOverAll == true ? yarnProjectionOverAllReport : yarnProjectionReportsList}
                                keyExpr={'slNo'}
                                showBorders={true}
                                columnAutoWidth={true}
                                allowColumnReordering={true}
                                rowAlternationEnabled={true}
                                onExporting={onExporting}
                                hoverStateEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode="widget"
                            >
                                <FilterRow visible={true} applyFilter="auto" />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <SearchPanel visible={true} width={240} placeholder="Search..." />
                                <ColumnChooser enabled={true} />
                                <ColumnFixing enabled={true} />
                                <Scrolling rowRenderingMode="virtual"></Scrolling>
                                <Paging defaultPageSize={10} />
                                <Pager
                                    visible={true}
                                    showPageSizeSelector={true}
                                    allowedPageSizes={allowedPageSizes}
                                    showNavigationButtons={true}
                                    showInfo={true}
                                    infoText="Page #{0}. Total: {1} ({2} items)"
                                />

                                {isOverAll == false && <Column headerCellRender={renderTitleHeader} dataField="fldYearAndMonthAsString" caption="Year & Month"></Column>}





                                <Column headerCellRender={renderTitleHeader} dataField="fldMillName" caption="Mill Name"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldAgentName" caption="Agent Name"></Column>

                                <Column headerCellRender={renderTitleHeader} dataField="fldSupplierName" caption="Supplier Name"></Column>



                                <Column headerCellRender={renderTitleHeader} dataField="fldYarnDescription" caption="Yarn Description"></Column>

                                <Column headerCellRender={renderTitleHeader} dataField="fldNoofBags" caption="No of Bags"></Column>


                                <Column headerCellRender={renderTitleHeader} dataField="fldProjectionQty" caption="Projection Qty(Kg)"></Column>


                                <Column headerCellRender={renderTitleHeader} dataField="fldPOQty" caption="PO Qty(Kg)"></Column>

                                <Column headerCellRender={renderTitleHeader} dataField="fldPendingQty" caption="Pending Qty(Kg)"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldPendingNoOfBags" caption="Pending No Of Bags" format={{ type: "fixedPoint", precision: 2 }}></Column>
                                <Export formats={exportFormats} enabled={true} allowExportSelectedData={true} />
                            </DataGrid>}

                            {!isReportScreen && <DataGrid
                                dataSource={yarnProjectionList}
                                keyExpr={'fldId'}
                                showBorders={true}
                                columnAutoWidth={true}
                                allowColumnReordering={true}
                                rowAlternationEnabled={true}
                                onExporting={onExporting}
                                hoverStateEnabled={true}
                                allowColumnResizing={true}
                                columnResizingMode="widget"
                            >
                                <FilterRow visible={true} applyFilter="auto" />
                                <FilterPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <SearchPanel visible={true} width={240} placeholder="Search..." />
                                <ColumnChooser enabled={true} />
                                <ColumnFixing enabled={true} />
                                <Scrolling rowRenderingMode="virtual"></Scrolling>
                                <Paging defaultPageSize={10} />
                                <Pager
                                    visible={true}
                                    showPageSizeSelector={true}
                                    allowedPageSizes={allowedPageSizes}
                                    showNavigationButtons={true}
                                    showInfo={true}
                                    infoText="Page #{0}. Total: {1} ({2} items)"
                                />



                                <Column headerCellRender={renderTitleHeader} dataField="fldGroupPRNo" fixed={true} caption="PR No">

                                </Column>

                                <Column
                                    headerCellRender={renderTitleHeader}
                                    dataType="date"
                                    dataField="fldPRDate"
                                    format="dd-MMM-yy"
                                    caption="PR Date"
                                >

                                </Column>

                                <Column headerCellRender={renderTitleHeader} dataField="fldCombinedSlNo" caption="Combined SlNo">

                                </Column>






                                <Column headerCellRender={renderTitleHeader} dataField="fldSupplierName" caption="Supplier Name"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldMillName" caption="Mill Name"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldAgentName" caption="Agent Name"></Column>

                                {/* <Column headerCellRender={renderTitleHeader} dataField="fldColor" caption="Color"></Column> */}
                                <Column headerCellRender={renderTitleHeader} dataField="fldYarnDescription" caption="Yarn Description"></Column>



                                <Column headerCellRender={renderTitleHeader} dataField="fldBagWeight" caption="Bag Weight(Kg)"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldNoofBags" caption="No of Bags"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldRate" caption="Rate"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldPRWeight" caption="PR Weight(Kg)"></Column>
                                <Column headerCellRender={renderTitleHeader} dataField="fldRemarks" caption="Remarks"></Column>
                                <Column headerCellRender={renderTitleHeader} caption="Actions" type="buttons" width={110}>
                                    <ActionButton text="Print" icon="print" hint="print" onClick={invoiceClick} />
                                    <ActionButton text="Edit" icon="edit" hint="Edit" onClick={editClick} />
                                    <ActionButton
                                        cssClass="text-danger"
                                        id="deleteButton"
                                        text="Delete"
                                        icon="trash"
                                        hint="Call Off"
                                        onClick={deleteClick}
                                    />
                                </Column>


                                <Summary>
                                    <TotalItem column="fldDescription" summaryType="count" />
                                </Summary>
                                <Export formats={exportFormats} enabled={true} allowExportSelectedData={true} />
                            </DataGrid>}


                        </div>

                    </Card.Body>
                </Card>
            </Col>
        </Row >
    );
};

export default YarnProjection;
